import React from 'react';
import './how-it-works.sass';
import ArrowsOne from '../../assets/Arrows_one.png';
import ArrowsTwo from '../../assets/Arrows_two.png';

export const HowItWorks = () => {

    return (
        <div className='vv-landing-page-vendor-how-it-woks-container'>
            <div className='vv-landing-page-vendor-how-it-woks'>
                <h4>JAK TO DZIAŁA?</h4>
                <div className='vv-landing-page-vendor-how-it-woks__step_container'>
                    <div className='vv-landing-page-vendor-how-it-woks__step'>
                        <h1>1</h1>
                        <div className='vv-landing-page-vendor-how-it-woks__step-column'>
                            <h3>Wybierasz komu dajesz zniżki na podstawie rodzaju wydarzenia</h3>
                            <p>W naszej bezie są setki różnorodnych wydarzeń w całej Polsce. Koncerty, mecze, spektakle, wystawy, seanse kinowe i wiele innych. Dobieraj swoich gości na podstawie rodzaju wydarzenia oraz gatunku muzycznego, czy dyscypliny sportowej</p>
                        </div>
                    </div>
                    <div className='vv-landing-page-vendor-how-it-woks__arrows'>
                        <img className='vv-landing-page-vendor-how-it-woks__step-image' src={ArrowsOne} style={{width: '109px'}} alt='Arrows'/>
                    </div>
                    <div className='vv-landing-page-vendor-how-it-woks__step'>
                        <h1>2</h1>
                        <div className='vv-landing-page-vendor-how-it-woks__step-column'>
                            <h3>Zarządzasz czasem obowiązywania i wysokością zniżki aby zapełnić swoj lokal</h3>
                            <p>W Viceversa możesz ustalić wysokość i czas obowiązywania zniżki co do minuty. Zarządzaj obłożeniem lokalu w nowoczesny sposób i spraw, że będzie tętnił życiem nawet w nietypowych godzinach.</p>
                        </div>
                    </div>
                    <div className='vv-landing-page-vendor-how-it-woks__arrows'>
                        <img className='vv-landing-page-vendor-how-it-woks__step-image' src={ArrowsTwo} style={{width: '207px'}} alt='Arrows'/>
                    </div>
                    <div className='vv-landing-page-vendor-how-it-woks__step'>
                        <h1>3</h1>
                        <div className='vv-landing-page-vendor-how-it-woks__step-column'>
                            <h3>Cieszysz się pełnym lokalem, nowymi klientami i statystykami</h3>
                            <p>W Viceversa możesz ustalić wysokość i czas obowiązywania zniżki co do minuty. Zarządzaj obłożeniem lokalu w nowoczesny sposób i spraw, że będzie tętnił życiem nawet w nietypowych godzinach.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};